/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CompanyDocument,
  CompanyDocumentDataFromHubble,
  DocumentDownloadResponse,
  GetCompanyDocumentResponse,
  ImageResponse,
} from "../models/index";
import {
  CompanyDocumentFromJSON,
  CompanyDocumentToJSON,
  CompanyDocumentDataFromHubbleFromJSON,
  CompanyDocumentDataFromHubbleToJSON,
  DocumentDownloadResponseFromJSON,
  DocumentDownloadResponseToJSON,
  GetCompanyDocumentResponseFromJSON,
  GetCompanyDocumentResponseToJSON,
  ImageResponseFromJSON,
  ImageResponseToJSON,
} from "../models/index";

export interface DeleteCompanyDocumentRequest {
  documentId: string;
}

export interface DownloadCompanyDocumentRequest {
  s3Key: string;
  contentType?: string | null;
}

export interface DownloadCompanyDocumentByIdRequest {
  documentId: string;
}

export interface DownloadCompanyDocumentThumbnailRequest {
  thumbnailKey: string;
}

export interface ExtractCompanyDocumentFromExistingRequest {
  s3Key: string;
  pages: Array<number>;
  companyDocumentDataFromHubble: CompanyDocumentDataFromHubble;
}

export interface GetCompanyDocumentRequest {
  documentId: string;
}

export interface GetCompanyDocumentsRequest {
  companyId: string;
}

export interface InsertCompanyDocumentsRequest {
  companyDocumentDataFromHubble: Array<CompanyDocumentDataFromHubble>;
}

export interface UpdateCompanyDocumentRequest {
  documentId: string;
  companyDocumentDataFromHubble: CompanyDocumentDataFromHubble;
}

/**
 *
 */
export class CompanyDocumentsApi extends runtime.BaseAPI {
  /**
   */
  async deleteCompanyDocumentRaw(
    requestParameters: DeleteCompanyDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["documentId"] == null) {
      throw new runtime.RequiredError(
        "documentId",
        'Required parameter "documentId" was null or undefined when calling deleteCompanyDocument().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["documentId"] != null) {
      queryParameters["documentId"] = requestParameters["documentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-documents/delete-company-document`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteCompanyDocument(
    requestParameters: DeleteCompanyDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteCompanyDocumentRaw(requestParameters, initOverrides);
  }

  /**
   */
  async downloadCompanyDocumentRaw(
    requestParameters: DownloadCompanyDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DocumentDownloadResponse>> {
    if (requestParameters["s3Key"] == null) {
      throw new runtime.RequiredError(
        "s3Key",
        'Required parameter "s3Key" was null or undefined when calling downloadCompanyDocument().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["s3Key"] != null) {
      queryParameters["s3Key"] = requestParameters["s3Key"];
    }

    if (requestParameters["contentType"] != null) {
      queryParameters["contentType"] = requestParameters["contentType"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-documents/download-company-document`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DocumentDownloadResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadCompanyDocument(
    requestParameters: DownloadCompanyDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DocumentDownloadResponse> {
    const response = await this.downloadCompanyDocumentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async downloadCompanyDocumentByIdRaw(
    requestParameters: DownloadCompanyDocumentByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DocumentDownloadResponse>> {
    if (requestParameters["documentId"] == null) {
      throw new runtime.RequiredError(
        "documentId",
        'Required parameter "documentId" was null or undefined when calling downloadCompanyDocumentById().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["documentId"] != null) {
      queryParameters["documentId"] = requestParameters["documentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-documents/download-company-document-by-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DocumentDownloadResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadCompanyDocumentById(
    requestParameters: DownloadCompanyDocumentByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DocumentDownloadResponse> {
    const response = await this.downloadCompanyDocumentByIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async downloadCompanyDocumentThumbnailRaw(
    requestParameters: DownloadCompanyDocumentThumbnailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ImageResponse>> {
    if (requestParameters["thumbnailKey"] == null) {
      throw new runtime.RequiredError(
        "thumbnailKey",
        'Required parameter "thumbnailKey" was null or undefined when calling downloadCompanyDocumentThumbnail().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["thumbnailKey"] != null) {
      queryParameters["thumbnailKey"] = requestParameters["thumbnailKey"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-documents/download-company-document-thumbnails`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ImageResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadCompanyDocumentThumbnail(
    requestParameters: DownloadCompanyDocumentThumbnailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ImageResponse> {
    const response = await this.downloadCompanyDocumentThumbnailRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async extractCompanyDocumentFromExistingRaw(
    requestParameters: ExtractCompanyDocumentFromExistingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["s3Key"] == null) {
      throw new runtime.RequiredError(
        "s3Key",
        'Required parameter "s3Key" was null or undefined when calling extractCompanyDocumentFromExisting().',
      );
    }

    if (requestParameters["pages"] == null) {
      throw new runtime.RequiredError(
        "pages",
        'Required parameter "pages" was null or undefined when calling extractCompanyDocumentFromExisting().',
      );
    }

    if (requestParameters["companyDocumentDataFromHubble"] == null) {
      throw new runtime.RequiredError(
        "companyDocumentDataFromHubble",
        'Required parameter "companyDocumentDataFromHubble" was null or undefined when calling extractCompanyDocumentFromExisting().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["s3Key"] != null) {
      queryParameters["s3Key"] = requestParameters["s3Key"];
    }

    if (requestParameters["pages"] != null) {
      queryParameters["pages"] = requestParameters["pages"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-documents/extract-company-document-from-existing`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CompanyDocumentDataFromHubbleToJSON(
          requestParameters["companyDocumentDataFromHubble"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async extractCompanyDocumentFromExisting(
    requestParameters: ExtractCompanyDocumentFromExistingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.extractCompanyDocumentFromExistingRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async getCompanyDocumentRaw(
    requestParameters: GetCompanyDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetCompanyDocumentResponse>> {
    if (requestParameters["documentId"] == null) {
      throw new runtime.RequiredError(
        "documentId",
        'Required parameter "documentId" was null or undefined when calling getCompanyDocument().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["documentId"] != null) {
      queryParameters["documentId"] = requestParameters["documentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-documents/get-company-document`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetCompanyDocumentResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getCompanyDocument(
    requestParameters: GetCompanyDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetCompanyDocumentResponse> {
    const response = await this.getCompanyDocumentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCompanyDocumentsRaw(
    requestParameters: GetCompanyDocumentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyDocument>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getCompanyDocuments().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/company-documents/get-company-documents`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyDocumentFromJSON),
    );
  }

  /**
   */
  async getCompanyDocuments(
    requestParameters: GetCompanyDocumentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyDocument>> {
    const response = await this.getCompanyDocumentsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async insertCompanyDocumentsRaw(
    requestParameters: InsertCompanyDocumentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyDocumentDataFromHubble"] == null) {
      throw new runtime.RequiredError(
        "companyDocumentDataFromHubble",
        'Required parameter "companyDocumentDataFromHubble" was null or undefined when calling insertCompanyDocuments().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-documents/insert-company-documents`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters["companyDocumentDataFromHubble"]!.map(
          CompanyDocumentDataFromHubbleToJSON,
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async insertCompanyDocuments(
    requestParameters: InsertCompanyDocumentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.insertCompanyDocumentsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateCompanyDocumentRaw(
    requestParameters: UpdateCompanyDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["documentId"] == null) {
      throw new runtime.RequiredError(
        "documentId",
        'Required parameter "documentId" was null or undefined when calling updateCompanyDocument().',
      );
    }

    if (requestParameters["companyDocumentDataFromHubble"] == null) {
      throw new runtime.RequiredError(
        "companyDocumentDataFromHubble",
        'Required parameter "companyDocumentDataFromHubble" was null or undefined when calling updateCompanyDocument().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["documentId"] != null) {
      queryParameters["documentId"] = requestParameters["documentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/company-documents/update-company-document`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CompanyDocumentDataFromHubbleToJSON(
          requestParameters["companyDocumentDataFromHubble"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateCompanyDocument(
    requestParameters: UpdateCompanyDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateCompanyDocumentRaw(requestParameters, initOverrides);
  }
}
